<wsd-extended-card
  [info]="entityLevel === searchEntityLevels.ORGANIZATION"
  (infoClicked)="modalVisible = !modalVisible"
  [title]="'DATA_PORTAL.REPORTING_COMPLIANCY.TITLE' | translate"
  [loading]="!(compliancy$ | async)">
  <div *ngIf="compliancy$ | async as compliancy" class="text-center">
    <wsd-radial-progress
      [progress]="compliancy.compliancyPercent / 100">
    </wsd-radial-progress>
  </div>
</wsd-extended-card>

<p-dialog
  [header]="'DATA_PORTAL.REPORTING_COMPLIANCY.MODAL_TITLE' | translate"
  [(visible)]="modalVisible">

  <div *ngIf="entityLevel === searchEntityLevels.ORGANIZATION">
    <div class="ui-g" *ngIf="compliancy$ | async as compliancy">
      <div class="ui-g-12">
        <p>{{ 'DATA_PORTAL.REPORTING_COMPLIANCY.INFO_TEXT' | translate }}</p>
      </div>
      <div class="ui-g-12">
        <p>
          <i class="fa m-r-5"
             [ngClass]="compliancy.annualReportingCompliancy ? 'fa-check text-success' : 'fa-flag text-danger'"></i>
          {{'DATA_PORTAL.REPORTING_COMPLIANCY.ANNUAL_REPORT' | translate}}
        </p>
        <p>
          <i class="fa m-r-5"
             [ngClass]="compliancy.censusCompliancy ? 'fa-check text-success' : 'fa-flag text-danger'"></i>
          {{'DATA_PORTAL.REPORTING_COMPLIANCY.CENSUS' | translate}}
        </p>
        <p>
          <i class="fa m-r-5"
             [ngClass]="compliancy.constitutionCompliancy ? 'fa-check text-success' : 'fa-flag text-danger'"></i>
          {{'DATA_PORTAL.REPORTING_COMPLIANCY.CONSTITUTION' | translate}}
        </p>
        <p>
          <i class="fa m-r-5"
             [ngClass]="compliancy.contactCompliancy ? 'fa-check text-success' : 'fa-flag text-danger'"></i>
          {{'DATA_PORTAL.REPORTING_COMPLIANCY.UPDATE_CONTACT' | translate}}
        </p>
        <p>
          <i class="fa m-r-5"
             [ngClass]="compliancy.financialReportingCompliancy ? 'fa-check text-success' : 'fa-flag text-danger'"></i>
          {{'DATA_PORTAL.REPORTING_COMPLIANCY.FINANCIAL_STATEMENT' | translate}}
        </p>
      </div>
    </div>
  </div>
</p-dialog>
